function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M8.04652 0.0137387C5.9159 0.0138804 3.87259 0.879697 2.36606 2.42074C0.859533 3.96178 0.0131836 6.05182 0.0131836 8.23111C0.0148926 10.4098 0.862435 12.4987 2.36947 14.0384L2.36529 14.0427L4.63737 16.3666L16.0004 27.9865L27.3618 16.3656L23.9531 12.8796L20.545 16.3656L16.0004 21.0141L11.4557 16.3656L8.04757 19.8515L4.63894 16.365L8.04757 12.8785L5.7755 10.5545L5.77657 10.5535C5.17356 9.93766 4.83436 9.10211 4.83354 8.23055C4.83347 7.79885 4.91653 7.37137 5.078 6.97252C5.23946 6.57367 5.47616 6.21125 5.77457 5.90598C6.07299 5.6007 6.42726 5.35853 6.81718 5.19332C7.2071 5.0281 7.62502 4.94306 8.04707 4.94306C8.89935 4.94376 9.71646 5.29073 10.3186 5.90764L10.3197 5.90654L12.5918 8.23052L15.9999 4.74402L13.7278 2.42004L13.7241 2.42432C12.2189 0.882662 10.1767 0.0155615 8.04657 0.0136719L8.04652 0.0137387Z",
  fill: "#E8463D"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M23.9538 0.0126953C21.8237 0.0144433 19.7815 0.881346 18.2762 2.4228L18.2725 2.41853L16.0005 4.74304L12.5913 8.23061L15.9999 11.7171L21.6807 5.90663L21.6823 5.90773C22.2844 5.29115 23.1013 4.94439 23.9533 4.94369C24.3754 4.94362 24.7933 5.02858 25.1832 5.19373C25.5732 5.35889 25.9275 5.60099 26.226 5.90622C26.5244 6.21144 26.7612 6.57382 26.9227 6.97265C27.0842 7.37148 27.1674 7.79894 27.1674 8.23063C27.1665 9.1022 26.8273 9.93774 26.2243 10.5535L26.2259 10.5546L23.9528 12.8797L27.3615 16.3657L27.362 16.3651L29.6346 14.0411L29.6309 14.0368C31.1378 12.4973 31.9854 10.4086 31.9872 8.23012C31.9872 6.05083 31.1409 3.96079 29.6343 2.41975C28.1278 0.878711 26.0845 0.0128871 23.9539 0.0127455L23.9538 0.0126953Z",
  fill: "#4788F1"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M23.9529 12.8804L20.5454 16.3658L16.0007 21.0143L11.456 16.3658L8.04736 19.8523L16.0007 27.9868L27.3616 16.3663L23.9529 12.8804Z",
  fill: "#3BA757"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.5915 8.23096L12.5909 8.23151L4.63867 16.3654L8.0473 19.8519L11.4559 16.3654L16.0001 11.7175L12.5915 8.23096Z",
  fill: "#F8BA2E"
});

var SvgSourceGooglefit = function SvgSourceGooglefit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 32,
    height: 28,
    viewBox: "0 0 32 28",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSourceGooglefit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/source_googlefit.221bc59b.svg";
export { ForwardRef as ReactComponent };